import React, { useState, useEffect } from "react";
import CreateProjectFooter from "../CreateProjectFooter/CreateProjectFooter";
import { Row, Col } from "react-bootstrap";
import AddServiceDescriptions from "./AddServiceDescriptions";
import AccordianDrop from "@components/AccordianDrop/AccordianDrop";
import { getAccordianHeaderMarkup } from "../Services/serviceHelpers";
import { faCirclePlus } from "@fortawesome/pro-light-svg-icons";
import "../Services/Services.css";
import API from "@API";
import useProjectServicesData from "../Services/api/useProjectServicesData";

function ServiceDescriptions({
  account_slug,
  authorizationCode,
  projectId,
  patchProjectUrl,
  setCurrentPage,
  pageReturn,
  setPageReturn,
  projectServiceData,
  setProjectServiceData,
  setHasBeenToAddServiceDescriptions,
  hasBeenToAddServiceDescriptions,
}) {
  // Env/ API
  const apiHost = process.env.REACT_APP_SCOPESTACK_API_HOST;
  const appHost = process.env.REACT_APP_DOORKEEPER_APP_URL;

  // States
  const [subpage, setSubpage] = useState("accordion");
  const [languageFields, setLanguageFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [projectData, setProjectData] = useState({});

  const { data, error, loaded } = useProjectServicesData({
    account_slug,
    authorizationCode,
    projectId,
  });

  useEffect(() => {
    if (data === null) {
      setIsLoading(true);
    } else {
      setProjectData(data);
      setProjectServiceData(data);
      setIsLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (hasBeenToAddServiceDescriptions) {
      setSubpage("addServiceDescriptions");
    }
    // Get Language Fields
    API.Get(
      `${apiHost}/${account_slug}/v1/language-fields`,
      authorizationCode
    ).then((response) => {
      let data = response.data.data;
      let serviceDescription = {
        id: 0,
        type: "language-fields",
        attributes: {
          name: "Service Description",
          "sow-language": "service_description",
        },
      };
      data.unshift(serviceDescription);
      setLanguageFields(data);
    });
  }, []);

  const continueProjectCreationWorkFlow = () => {
    setCurrentPage(4);
  };

  const accordionSubtitle = (
    <>
      <div>
        These descriptons include things like out-of-scope items, deliverables,
        and service descriptions themselves. If you added services from{" "}
        <strong>Standards</strong> or <strong>Blueprints</strong>, pre-defined
        verbiage will be included. For <strong>Custom</strong> services, you can
        add custom verbiage. These language fields will be included in the
        document template automatically.
      </div>
    </>
  );

  const ServiceDescriptionAccordions = () => (
    <Row
      className="accordianRedirect"
      onClick={() => {
        setSubpage("addServiceDescriptions");
        setHasBeenToAddServiceDescriptions(true);
      }}
    >
      <Col>
        <AccordianDrop
          header={getAccordianHeaderMarkup(
            "Add / Edit Service Descriptions",
            accordionSubtitle
          )}
          body={null}
          iconOpen={faCirclePlus}
          iconClosed={faCirclePlus}
          closeable={false}
          setAccordianIsOpen={null}
          className="serviceDescriptionAccordion mainAccordion"
        />
      </Col>
    </Row>
  );

  const renderSubpages = () => {
    switch (subpage) {
      case "addServiceDescriptions":
        return (
          <AddServiceDescriptions
            authorizationCode={authorizationCode}
            account_slug={account_slug}
            subpage={subpage}
            setSubpage={(subpage) => setSubpage(subpage)}
            projectServiceData={projectData}
            languageFields={languageFields}
            isLoading={isLoading}
          />
        );
      case "accordion":
        return <ServiceDescriptionAccordions />;
    }
  };

  const backToServicesAdded = () => {
    setCurrentPage(2);
    setPageReturn(true);
  };

  return (
    <>
      <div className="details">{renderSubpages()}</div>
      <CreateProjectFooter
        previousTabName={"Services Added"}
        backButtonOnClick={backToServicesAdded}
        continueButtonType={"button"}
        continueButtonOnClick={() => continueProjectCreationWorkFlow()}
        disabled={subpage == "accordion"}
      />
    </>
  );
}

export default ServiceDescriptions;
